<template>
  <div class="skeleton-loader-white" :style="`height: ${height}px`" :title="title"/>
</template>

<script>
export default {
  name: "SkeletonDiv",
  props: {
    // width: {
    //   type: Number,
    //   default: 100,
    // },
    height: {
      type: Number,
      default: 100,
    },
    title: {
      type: String,
      default: 'Chargement...',
    },
  },
}
</script>

<style lang="scss" scoped>
.skeleton-loader-white {
  width: 100%;
  display: block;
  background-color: #bdc3c7 !important;
  border-color: #bdc3c7 !important;
  animation-name: skeletonAnimation;
  animation-duration: 1.5s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}

@keyframes skeletonAnimation {
  0% {
    opacity: 0.8;
  }
  50% {
    opacity: 0.4;
  }
  100% {
    opacity: 0.8;
  }
}
</style>
